export default "__VITE_ASSET__IFTfXz9F__"